"use client";

import { useEffect } from "react";
import { syncCartCookies } from "@/app/actions/cart";

export function CartSessionSync() {
  useEffect(() => {
    void syncCartCookies().catch(() => {
      // No database, guest cart stays on mock/sample flow.
    });
  }, []);

  return null;
}
